import { Dropdown, DropdownProps, Layer } from '@carbon/react';
import { ReactNode } from 'react';
import classNames from 'classnames';
import style from './dropdown-field.module.scss';

interface DropdownFieldProps<
  Items extends string | null | undefined,
> extends Omit<
  DropdownProps<Items>,
  'selectedItem' | 'onChange' | 'light' | 'titleText'
> {
  value: Items;
  onChange: (value: Items) => void;
  onBlur?: () => void;
  titleText?: ReactNode;
  required?: boolean;
  invalid?: boolean;
  invalidText?: string;
  disabled?: boolean;
  light?: boolean;
}

const DropdownField = <Items extends string | null | undefined>({
  value,
  onChange,
  onBlur,
  titleText,
  required,
  invalid,
  invalidText,
  disabled,
  light,
  ...rest
}: DropdownFieldProps<Items>) => {
  const dropdown = (
    <Dropdown<Items>
      titleText={
        <label>
          {titleText}
          {required && <span className={style.required}> (Required)</span>}
        </label>
      }
      selectedItem={value ?? (null as Items)}
      onChange={(event) => {
        if (
          typeof event.selectedItem !== 'undefined' &&
          event.selectedItem !== null
        ) {
          onChange(event.selectedItem);
        }
      }}
      onBlur={onBlur}
      itemToString={(item) => item ?? ''}
      invalid={invalid}
      invalidText={invalid ? invalidText : ''}
      disabled={disabled}
      {...rest}
    />
  );

  return (
    <div
      className={classNames({
        [style.light]: light ?? false,
        [style.disabled]: disabled,
      })}
    >
      {(light ?? true) ? <Layer>{dropdown}</Layer> : dropdown}
    </div>
  );
};

export { DropdownField };
